import React from "react";

import { Callout } from "src/design-system/Callout";
import { ModelOption } from "src/genai/ModelSelector/types";

type UpgradeNudgeProps = {
  model: ModelOption;
  successor: ModelOption;
  /** The single call-to-action (e.g. "Switch model" when editable, else "Dismiss"). */
  action: { text: string; onClick: () => void };
};

/**
 * Inline prompt shown below the trigger when the selected model has a newer
 * recommended successor.
 */
export const UpgradeNudge: React.FC<UpgradeNudgeProps> = ({
  model,
  successor,
  action,
}) => (
  <div className="mt-2.5">
    <Callout action={action} dataLoc="upgrade-nudge" variant="info">
      {model.displayName} is superseded by{" "}
      <span className="font-inter-medium-12px">{successor.displayName}</span>.
    </Callout>
  </div>
);
